export const LOGIN_TOKEN = 'Token'

export const ORDER_TIME = 60 * 1000

export const KEY =
  'MFkwEwYHKoZIzj0CAQYIKoEcz1UBgi0DQgAEqwFQBaXDGZpOXo2lWdwsczbch9N/HVSb+nOOtYE308VkvWocybpcsL0IbiJ7PChjdyP5D1uutgoJA1FPKuuX1A=='
